import React from 'react';
import SearchWithParams from '../components/SearchWithParams';

const SearchByKeyword = props => (
    <SearchWithParams mode="keyword" {...props} />
);

export default SearchByKeyword;
